import Controller from '@ember/controller';

import { WelcomeIndexPage } from 'register-partners-js/react/components/welcome-index';

export default class WelcomeController extends Controller {
  welcomeIndexPage = WelcomeIndexPage;
}
